// Shared XP/level math for global level progression.
// Level N requires round(100 * (1.55^(N-1) - 1)) total XP; flattening: x1.55 per level.

export const getExperienceForLevel = (level) => {
    if (level <= 1) return 0
    return Math.round(100 * (Math.pow(1.55, level - 1) - 1))
}

export const getExperienceToNextLevel = (currentXp) => {
    const currentLevel = Math.floor(Math.log(Math.max(currentXp, 0) / 100 + 1) / Math.log(1.55)) + 1
    const nextLevelXp = getExperienceForLevel(currentLevel + 1)
    return Math.max(0, nextLevelXp - currentXp)
}

export const getProgressToNextLevel = (currentXp) => {
    const currentLevel = Math.floor(Math.log(Math.max(currentXp, 0) / 100 + 1) / Math.log(1.55)) + 1
    const currentLevelXp = getExperienceForLevel(currentLevel)
    const nextLevelXp = getExperienceForLevel(currentLevel + 1)
    const xpInLevel = currentXp - currentLevelXp
    const xpNeededForLevel = nextLevelXp - currentLevelXp
    return xpNeededForLevel > 0 ? Math.round((xpInLevel / xpNeededForLevel) * 100) : 100
}
